export default __webpack_public_path__ + "static/media/Convit-B-200-ml-ban.a2d273a4.jpg";